import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Operation } from 'types';

import TableBody from 'modules/_shared/Table/components/TableBody';

import { useOperationsListPage } from '../context/OperationsListPageContext';

import OperationsTableRow from './OperationsTableRow';

const OperationsTableBody: FC = () => {
  const { t } = useTranslate();
  const { data } = useOperationsListPage();

  const hasData = data.operations?.length > 0;

  const rows = data.operations!.map((operation: Operation, index: number) => (
    <OperationsTableRow
      key={operation._id ?? `operation-row-${index}`}
      index={index}
      operation={operation}
    />
  ));

  return (
    <TableBody
      hasData={hasData}
      content={rows}
      noDataMessage={t('NoOperationsAvailable')}
    />
  );
};

export default OperationsTableBody;
